import { render, staticRenderFns } from "./SQuesThirtyEight.vue?vue&type=template&id=143d0856&scoped=true&"
import script from "./SQuesThirtyEight.vue?vue&type=script&lang=js&"
export * from "./SQuesThirtyEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d0856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
